import {
  getProvisionsList,
  getActivistNomineeOnBoardList,
  getStateOfIncorporationdList,
  getGovernanceAdvSearchReq,
} from '../config/server-config';
import { API_CALL_SUCCESSFULL } from '../constants/NumberConstants';
import { GOVERNANCE } from '../constants/ProductConstants';
import api from '../api';

export const GetProvisionsList = async () => {
  try {
    const response = await api.post(getProvisionsList);

    if (response.status === API_CALL_SUCCESSFULL) {
      return response.data;
    }
  } catch (error) {
    return false;
  }
};

export const GetActivistNomineeOnBoardList = async () => {
  try {
    const response = await api.post(getActivistNomineeOnBoardList, {});

    if (response.status === API_CALL_SUCCESSFULL) {
      return response.data;
    }
  } catch (error) {
    return false;
  }
};

export const GetStateOfIncorporationdList = async () => {
  try {
    const response = await api.post(getStateOfIncorporationdList, {});

    if (response.status === API_CALL_SUCCESSFULL) {
      return response.data;
    }
  } catch (error) {
    return false;
  }
};

export const GetGovernanceAdvSearchReq = async (
  company_search_id,
  StateOfIncorporation,
  BoardSizeMin,
  BoardSizeMax,
  PoisonPillOwnershipPcentMin,
  PoisonPillOwnershipPcentMax,
  PoisonPillExpiryDateMin,
  PoisonPillExpiryDateMax,
  AvgDirectorTimeMin,
  AvgDirectorTimeMax,
  AvgDirectorAgeMin,
  AvgDirectorAgeMax,
  AnyDirectorTimeMin,
  FemaleDirPcentMin,
  FemaleDirPcentMax,
  NomineeActivists,
  notParameters,
  yesParameters,
) => {
  try {
    const token = localStorage.getItem('token');
    const response = await api.post(getGovernanceAdvSearchReq, {
      company_search_id,
      StateOfIncorporation,
      BoardSizeMin,
      BoardSizeMax,
      PoisonPillOwnershipPcentMin,
      PoisonPillOwnershipPcentMax,
      PoisonPillExpiryDateMin,
      PoisonPillExpiryDateMax,
      AvgDirectorTimeMin,
      AvgDirectorTimeMax,
      AvgDirectorAgeMin,
      AvgDirectorAgeMax,
      AnyDirectorTimeMin,
      FemaleDirPcentMin,
      FemaleDirPcentMax,
      NomineeActivists,
      notParameters,
      yesParameters,
      product_id: GOVERNANCE,
      token,
    });

    if (response.status === API_CALL_SUCCESSFULL) {
      return response.data;
    }
  } catch (error) {
    return false;
  }
};
